<!--路线合并的路线  -->
<template>
	<div class="dialogBox">
		<el-dialog title="选择计划" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="800px" :before-close="cancle">
			<span slot="title" class="flex flex-middle">
				<div class="title">选择计划</div>
				<div class="flex ml15">
					<el-input v-model.trim="routeName" class="w190" size="small" placeholder="路线名称" maxlength="16"
						clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
				</div>
			</span>
			<div class="form-box" v-if="newFlag=='Y'">
				<el-table class="" ref="multipleTable" :row-key="(row)=>{ return row.planId}" :data="tableData"
					v-el-table-infinite-scroll="tableLoad" infinite-scroll-distance="10" infinite-scroll-immediate="false" height="300" @selection-change="handleSelectionChange"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}" border
					@row-click="handleRowClick1" style="width: 100%">
					<el-table-column type="selection" :reserve-selection="true" width="55">
					</el-table-column>
					<el-table-column prop="planCode" label="计划编号" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="planDate" label="计划日期" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="routeName" label="路线名称" :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>

			</div>
			<div v-else>
				<el-table class="mt10" ref="multipleTable" v-el-table-infinite-scroll="tableLoad" :data="tableData"
					height="300" :header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					@row-click="handleRowClick" border style="width: 100%">
					<el-table-column width="60" label="选择" align="center">
						<template slot-scope="scope">
							<el-radio v-model="selecteId" :label="scope.row.planId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="planCode" label="计划编号" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="planDate" label="计划日期" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="routeName" label="路线名称" :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				routeName: "",
				tableData: [],
				pageNo: 1,
				pageSize: 10,
				totalPage: 0,
				multipleSelection: [],
				newFlag: "",
				selecteId: '',
				selectList: [],
				infiniteFlag: false,
			}
		},
		created() {

		},
		methods: {
			init(selectList, newFlag) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.routeName = ""
					this.infiniteFlag=false
					this.newFlag = newFlag
					this.pageNo = 1
					this.getRouteList()
					this.selecteId = ""
					this.selectList = selectList

				})
			},

			//  获取列表
			getRouteList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"roundPlanList1",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							routeName: that.routeName,
							diffFlag:that.newFlag=='Y'?0:1
						}
					)
					.then((res) => {
						if(res.data) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							}
							if(type == 'scroll') {
								that.tableData = that.tableData.concat(res.data.list);
							}else {
								that.tableData = res.data.list;
							}
					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getRouteList('scroll');
			}, 200, true),
			// 搜索
			handleSearch() {
				this.pageNo = 1;
				this.infiniteFlag = false;
				this.getRouteList();

				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 列单选
			radioRow(val) {
				this.multipleSelection = [];
				this.multipleSelection.push(val)
			},
			// 点击行选中
			handleRowClick1(row, column, event) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			// 点击行选中
			handleRowClick(row, column, event) {
				this.selecteId = row.dataKey;
				this.multipleSelection = [];
				this.multipleSelection.push(row)
			},
			// 保存
			submitForm: debounce(function () {
				let newArr = this.unRepeat(this.multipleSelection, this.selectList)
				if (newArr.length > 10) {
					this.$message.error('只能添加10条路线!');
					return
				}
				this.$emit("selectRows", this.multipleSelection)
				this.$emit("selectNewFlag", this.newFlag)
				this.dialogVisible = false
			}, 1000, true),
			// 去重
			unRepeat(json1, json2) {
				let json = json1.concat(json2); //两个数组对象合并
				let newJson = []; //盛放去重后数据的新数组
				json.forEach(item1 => {
					let flag = true; //建立标记，判断数据是否重复，true为不重复
					newJson.forEach(item2 => {
						if (item1.planCode == item2.planCode) { //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
							flag = false;
						}
					});
					if (flag) { //判断是否重复
						newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
					}
				});
				return newJson
			},
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}

	.el-dialog__body {
		height: 500px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

</style>
